var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.2 15.2",
    style: {
      enableBackground: "new 0 0 15.2 15.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,7.6l5.4-5.4C15,2,15.1,1.7,15.1,1.4c0-0.3-0.1-0.7-0.4-0.9c-0.2-0.2-0.6-0.4-0.9-0.4 c-0.3,0-0.7,0.1-0.9,0.4L7.6,5.8L2.2,0.5C2,0.2,1.7,0.1,1.4,0.1C1,0.1,0.7,0.2,0.5,0.5C0.2,0.7,0.1,1,0.1,1.4c0,0.3,0.1,0.7,0.4,0.9 l5.4,5.4L0.5,13c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.2-0.1,0.3-0.1,0.5c0,0.2,0,0.3,0.1,0.5c0.1,0.2,0.2,0.3,0.3,0.4 C0.6,14.9,0.7,15,0.9,15c0.2,0.1,0.3,0.1,0.5,0.1c0.2,0,0.3,0,0.5-0.1C2,15,2.1,14.9,2.2,14.7l5.4-5.4l5.4,5.4 c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.1,0.3,0.1,0.5,0.1c0.2,0,0.3,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.3,0.3-0.4 c0.1-0.2,0.1-0.3,0.1-0.5c0-0.2,0-0.3-0.1-0.5c-0.1-0.2-0.2-0.3-0.3-0.4L9.4,7.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.105abb4473c135d1613d0bb71e0550e2.svg";
export { ForwardRef as ReactComponent };